import cn from 'classnames';
interface Props {
  children: React.ReactNode;
  isOpen?: boolean;
}
export const SplitRow = ({ children, isOpen = false }: Props) => {
  return (
    <div
      className={cn(
        'relative grid w-full grid-cols-[2fr_1fr_1fr_2rem] items-center gap-x-5 gap-y-4 rounded-regular border-neutral-90 bg-white px-4 py-3 first:border-none sm:grid-cols-[1fr_3rem_8rem_2rem]',
        {
          'rounded-b-none border-b first:!border-solid': isOpen,
        },
      )}
    >
      {children}
    </div>
  );
};
